
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#141B34","stroke-width":"1.5","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M7.353 1.333c2.662 0 3.993 0 4.82.781C13 2.895 13 4.152 13 6.667v2.666c0 2.514 0 3.771-.827 4.553-.827.78-2.158.78-4.82.78h-.706c-2.662 0-3.993 0-4.82-.78C1 13.105 1 11.848 1 9.333V6.667c0-2.515 0-3.772.827-4.553.827-.78 2.158-.78 4.82-.78h.706zM4.333 4.667h5.334M4.333 8h5.334M4.333 11.333H7"}})])])
          )
        }
      }
    